module.exports = __webpack_public_path__ + "static/media/5.5.f2ada205.png";